import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class BenefitsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{BenefitsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>benefits go here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

BenefitsPage.meta = {
    label: <FormattedMessage id={'benefits'} defaultMessage={'Benefits'} />,
    icon: 'nature',
    action: () => history.push('/benefits'),
    locations: ['/benefits']
};

export default BenefitsPage;



// WEBPACK FOOTER //
// ./src/pages/benefits/index.jsx